export const FETCH_CREDIT = 'credit::fetch_credit';
export const FETCH_CREDIT_SUCCESS = 'credit::fetch_credit_success';
export const FETCH_CREDIT_ERROR = 'credit::fetch_credit_error';
export const TOGGLE_CREDIT = 'credit::toggle_credit';
export const TOGGLE_ALL_CREDIT = 'credit::toggle_all_credit';
export const CHANGE_PAYMENT_AMOUNT = 'credit::change_payment_amount';
export const CHANGE_ADHOC_PAYMENT = 'credit::change_adhoc_payment';


// WEBPACK FOOTER //
// ./src/action-types/credit.js